import { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import { Menu, MenuItem } from "@szhsin/react-menu";
import dayjs from "dayjs";

import Box from "@mui/material/Box";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";
import SubTitle from "../../components/SubTitle";

import {
  getTeacherNextWeek,
  updateProctorsToActivityDate,
} from "../../services/ActivityService";
import { hasError, getError } from "../../services/ServiceHelper";
import { doService } from "../../services/ServiceHelper";
import { getSchoolTeachers } from "../../services/SchoolService";
import SelectTeachersDialog from "../../components/faculty/SelectTeachersDialog";

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "../../ResponsiveTable.css";
import { showToast } from "../../components/ATPDialogs";
import { getPeriodName } from "../../services/SchoolService";

const NextWeek = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();

  const [_ownedActivities, setOwnedActivities] = useState([]);
  const [_proctoredActivites, setProctoredActivities] = useState([]);

  const [_proctorDialogOpen, setProctorDialogOpen] = useState(false);
  const navigate = useNavigate();

  const [showProgress, setShowProgress] = useState(false);
  const [_currentAd, setCurrentAd] = useState({});
  const [_allTeachers, setAllTeachers] = useState([]);
  const [_allTeachersMap, setAllTeachersMap] = useState([]);
  const [_selectedProctors, setSelectedProctors] = useState([]);
  const [_selectedActivityDate, setSelectedActivityDate] = useState({});

  useEffect(() => {
    initActivities();
  }, []);

  const initAllTeachers = () => {
    return doService(getSchoolTeachers(_school, _jwt), (results) => {
      const labeledLists = [];
      const map = {};
      for (const teacher of results.data) {
        map[teacher.eid] = teacher;
        labeledLists.push({
          label: teacher.last_name + ", " + teacher.first_name,
          value: teacher.eid,
        });
      }
      setAllTeachers(labeledLists);
      setAllTeachersMap(map);
    });
  };

  const initActivities = () => {
    setShowProgress(true);

    getTeacherNextWeek(_school, _jwt)
      .then((results) => {
        if (hasError(results) === true) {
          window.showSnack("Unable to get Activities: " + getError(results));
          return;
        }

        const allActivities = results.data;
        const ownedActivities = [];
        const proctoredActivities = [];

        for (let activity of allActivities) {
          if (activity.roleType === "O") {
            // owner
            ownedActivities.push(activity);
          } else {
            // proctor
            proctoredActivities.push(activity);
          }
        }

        setOwnedActivities(ownedActivities);
        setProctoredActivities(proctoredActivities);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const gotoViewAttendance = (activity) => {
    navigate(`/teacher/ad/${activity.activityDateEid}/attendance/view`);
  };

  const gotoTakeAttendance = (activity) => {
    navigate(`/teacher/ad/${activity.activityDateEid}/attendance/take`);
  };

  const showProctors = (activity) => {
    const dailyProctors = activity.dailyProctors;
    console.log(_allTeachersMap);

    const selectedProctors = [];
    // get from "all" list
    for (let proctor of dailyProctors) {
      console.log(proctor.eid);
      if (_allTeachersMap[proctor.eid] != null) {
        selectedProctors.push({
          label: proctor.last_name + ", " + proctor.first_name,
          value: proctor.eid,
        });
      }
    }

    setSelectedActivityDate(activity);
    setSelectedProctors(selectedProctors);

    if (_allTeachers.length === 0) {
      initAllTeachers().then(() => {
        // load proctors for activity...
        setProctorDialogOpen(true);
      });
    } else {
      setProctorDialogOpen(true);
    }
  };

  const handleCloseDialogProctor = () => setProctorDialogOpen(false);

  const handleOKProctor = (items) => {
    setProctorDialogOpen(false);
    const teacherEids = [];

    if (items.length === 0) {
      return;
    }

    for (const item of items) {
      teacherEids.push(item.value);
    }

    setShowProgress(true);
    doService(
      updateProctorsToActivityDate(
        _school,
        _jwt,
        _selectedActivityDate.activityDateEid,
        teacherEids,
      ),
      (results) => {
        setShowProgress(false);
        initActivities();
        showToast("S", "Updated Proctors");
      },
    );
  };

  const gotoSignup = (activity) => {
    navigate(`/teacher/ad/signup/${activity.activityDateEid}`);
  };

  const gotoAttend = (activity) => {
    navigate(`/teacher/ad/attend/${activity.activityDateEid}`);
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Next Week" showBack={true} />
        <ProgressBar showProgress={showProgress} />
        <Box sx={{ boxShadow: 1, p: 1, mt: 2 }}>
          <SubTitle text="My Activities" />

          <Table>
            <Thead>
              <Tr>
                <Th>Date/Day</Th>
                <Th>Period</Th>
                <Th>Name/Location</Th>
                <Th>Current/Max</Th>
                <Th>Proctors</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {_ownedActivities.map((activity) => (
                <Tr key={activity.activityDateId}>
                  <Td>
                    <span style={{ fontWeight: 600 }}>
                      {dayjs(activity.date).format("MM/DD/YYYY")}
                    </span>
                    <br />
                    {activity.fullDay}
                  </Td>
                  <Td>
                    {getPeriodName(_school, activity.period - 1, true, true)}
                  </Td>
                  <Td>
                    <span style={{ fontWeight: 600 }}>{activity.name}</span>
                    <br />
                    {activity.location}
                  </Td>
                  <Td>
                    {activity.currentAttendance}/{activity.maxAttendance}
                  </Td>
                  <Td>
                    {activity.dailyProctors.length === 0 && <>NO PROCTORS</>}

                    {activity.dailyProctors.length > 0 && (
                      <>
                        {activity.dailyProctors.map((proctor) => (
                          <>
                            {proctor.last_name}, {proctor.first_name}
                            <br />
                          </>
                        ))}
                      </>
                    )}
                  </Td>
                  <Td>
                    <Menu menuButton={<Button>Actions</Button>} transition>
                      {_school.canViewViewAttendance === "Y" && (
                        <MenuItem
                          value={activity.eid}
                          onClick={() => gotoViewAttendance(activity)}
                        >
                          View Attendance
                        </MenuItem>
                      )}
                      <MenuItem
                        value={activity.eid}
                        onClick={() => gotoTakeAttendance(activity)}
                      >
                        Take Attendance
                      </MenuItem>
                      <MenuItem
                        value={activity.eid}
                        onClick={() => {
                          setCurrentAd(activity);
                          showProctors(activity);
                        }}
                      >
                        Daily Proctors
                      </MenuItem>
                      <MenuItem
                        value={activity.eid}
                        onClick={() => gotoSignup(activity)}
                      >
                        QR - Signup
                      </MenuItem>
                      <MenuItem
                        value={activity.eid}
                        onClick={() => gotoAttend(activity)}
                      >
                        QR - Attendance
                      </MenuItem>{" "}
                    </Menu>
                  </Td>
                </Tr>
              ))}
              {_ownedActivities.length === 0 && (
                <Tr>
                  <Td colSpan={10}>-- NO ACTIVITIES --</Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Box>
        <Box sx={{ boxShadow: 1, p: 1, mt: 2 }}>
          <SubTitle text="Proctored Activities" />

          <Table>
            <Thead>
              <Tr>
                <Th>Date/Day</Th>
                <Th>Period</Th>
                <Th>Name/Location</Th>
                <Th>Current/Max</Th>
                <Th>Proctors</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {_proctoredActivites.map((activity) => (
                <Tr key={activity.activityDateId}>
                  <Td>
                    <span style={{ fontWeight: 600 }}>
                      {dayjs(activity.date).format("MM/DD/YYYY")}
                    </span>
                    <br />
                    {activity.fullDay}
                  </Td>
                  <Td>
                    {getPeriodName(_school, activity.period - 1, true, true)}
                  </Td>
                  <Td>
                    <span style={{ fontWeight: 600 }}>{activity.name}</span>
                    <br />
                    {activity.location}
                  </Td>
                  <Td>
                    {activity.currentAttendance}/{activity.maxAttendance}
                  </Td>
                  <Td>
                    {activity.dailyProctors.length === 0 && <>NO PROCTORS</>}

                    {activity.dailyProctors.length > 0 && (
                      <>
                        {activity.dailyProctors.map((proctor) => (
                          <>
                            {proctor.last_name}, {proctor.first_name}
                            <br />
                          </>
                        ))}
                      </>
                    )}
                  </Td>
                  <Td>
                    <Menu menuButton={<Button>Actions</Button>} transition>
                      {_school.canViewViewAttendance === "Y" && (
                        <MenuItem
                          value={activity.eid}
                          onClick={() => gotoViewAttendance(activity)}
                        >
                          View Attendance
                        </MenuItem>
                      )}
                      <MenuItem
                        value={activity.eid}
                        onClick={() => gotoTakeAttendance(activity)}
                      >
                        Take Attendance
                      </MenuItem>
                      <MenuItem
                        value={activity.eid}
                        onClick={() => gotoSignup(activity)}
                      >
                        QR - Signup
                      </MenuItem>
                      <MenuItem
                        value={activity.eid}
                        onClick={() => gotoAttend(activity)}
                      >
                        QR - Attendance
                      </MenuItem>{" "}
                    </Menu>
                  </Td>
                </Tr>
              ))}
              {_proctoredActivites.length === 0 && (
                <Tr>
                  <Td colSpan={10}>-- NO ACTIVITIES --</Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Box>
        <SelectTeachersDialog
          open={_proctorDialogOpen}
          onClose={handleCloseDialogProctor}
          onOK={handleOKProctor}
          teachers={_allTeachers}
        />{" "}
      </Container>
    </>
  );
};

export default NextWeek;
